import { Label } from 'api/api';
import * as React from 'react';

import { FullscreenMode } from '~src/main/fullscreen-internals/fullscreen-mode';
import { colors } from '~src/main/theme/colors';

import { LabelModalFullscreen } from './label-modal-fullscreen';

interface LabelComponentProps {
  categoryName: string;
  sortedLabels: Label[];
  label: Label;
}

export const LabelComponent: React.FC<LabelComponentProps> = ({
  categoryName,
  sortedLabels,
  label,
}) => {
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  // sustainability label should have different color.
  const color = label.type === 'LABEL_TYPE_SUSTAINABILITY' ? colors.green : 'inherit';
  /**
   * At least one label should have a description to show the modal.
   */
  const clickable = sortedLabels.some(label => !!label.description);

  return (
    <>
      <div
        css={{ display: 'flex', cursor: clickable ? 'pointer' : 'unset' }}
        onClick={clickable ? () => setModalOpen(true) : undefined}
        role="presentation"
      >
        <span css={{ color }}>{label.name}</span>
      </div>
      {modalOpen && (
        <FullscreenMode>
          <LabelModalFullscreen
            title={categoryName}
            labels={sortedLabels}
            onClose={() => setModalOpen(false)}
          />
        </FullscreenMode>
      )}
    </>
  );
};
